import styled from '@emotion/styled';
import { StyledHelpText } from '../help-text';

export const StyledInvalidMessage = styled(StyledHelpText)(({ theme }) => ({
    color: theme.colors.negative,
    [`+ ${StyledHelpText}`]: {
        display: 'none',
    },
}));
